import { combineReducers } from 'redux';
import { requestsReducer } from 'redux-requests';
import dictionary from './dictionary';
import homePage from './homePage';
import jobDetail from './jobDetail';
import { user } from './login';
import { breadcrumb } from './breadcrumb';
import { getUnleashDetails } from './unleashDetails';
import getAdvancedSearch from './advancedSearch';
import jobsReducer from './jobs';
import { singleUpload } from './singleUpload';
import jobDetailsReducer from './jobDetails';
import assetTypeReducer from './assetTypes';
import getSimpleSearch from './simpleSearch';
import { getSearchValues } from './searchValues';
import { loading } from './loading';
import inputValidationReducer from './inputValidation';
import submitValidationReducer from './submitValidation';
import dropdownOptionsReducer from './dropdownOptions';
import userTypeReducer from './userType';
import targetsiteErpMappingReducer from './targetsiteErpMapping';
import cascadeTableIDApiValues from './cascadeTableIDApiValues';
import cascaseDropDownOptions from './cascadeDropDownOptions';
import nifiReportReducer from './nifiReport';


export default combineReducers({
  requests: requestsReducer,
  dictionary,
  homePage,
  jobDetail,
  user,
  breadcrumb,
  getUnleashDetails,
  getAdvancedSearch,
  jobsReducer,
  singleUpload,
  jobDetailsReducer,
  assetTypeReducer,
  getSimpleSearch,
  getSearchValues,
  loading,
  inputValidationReducer,
  submitValidationReducer,
  dropdownOptionsReducer,
  userTypeReducer,
  targetsiteErpMappingReducer,
  cascadeTableIDApiValues,
  cascaseDropDownOptions,
  nifiReportReducer
});
